
import React from "react";
import { WebsiteDevelopment } from "./components/web-design";
import {Navigation} from "./components/navigation";
import { BackToTop } from "./components/BackToTop";
import { WhatsAppFloat } from "./components/WhatsAppFloat";


const phoneNumber = "1234567890"; // Replace with your actual phone number


export default function WebsitePackage(){
    return(
        <main className="min-h-screen font-poppins flex flex-col">
            <Navigation/>
            <WebsiteDevelopment/>
            <WhatsAppFloat phoneNumber={phoneNumber} />
            <BackToTop />
        </main>
    )
}